<div
  class="typography green-basic nowrap show-more-button"
  *ngIf="!isHiddenButton"
  (click)="showMoreContent()"
>
  Показать ещё&#8230;
</div>
